import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=b6929a4a&"
import script from "./TableBody.vue?vue&type=script&lang=ts&"
export * from "./TableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports